import type { CSSProperties } from "react";
import { Alert as AntdAlert, type AlertProps as AntdAlertProps } from "antd";
import { createStyles } from "antd-style";

import type { AvE2EProps } from "../types";

interface StyledAlertProps extends AvE2EProps, AntdAlertProps {
  style?: CSSProperties;
}

const useStyles = createStyles(({ token, css }) => ({
  alert: css`
    margin-top: ${token.marginXXS}px;
    margin-bottom: ${token.marginLG}px;
  `,
}));

function CustomAlert({ style, testIdPrefix, className, ...props }: StyledAlertProps) {
  const { styles } = useStyles();

  return (
    <AntdAlert
      data-testid={`${testIdPrefix}-alert`}
      {...props}
      className={`${styles.alert} ${className || ""}`}
      style={style}
    />
  );
}

export const Alert = Object.assign(CustomAlert, AntdAlert);
